// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1YY-9","col":"styles_col__3jAtX","fulfillmentStatus":"styles_fulfillmentStatus__174cv","emailCol":"styles_emailCol__wyEwe"};